export default __webpack_public_path__ + "static/media/img15.4acd0018.jpg";